<script setup lang="ts">
import DarwinButton from '@/uiKit/DarwinButton.vue'
import IconSprite from '@/uiKit/IconSprite.vue'
import Menu from '@/uiKit/Menu'

withDefaults(defineProps<{ size?: 'md' | 'xs' | 'sm' | 'lg' }>(), {
  size: 'sm',
})

const emit = defineEmits<{
  (e: 'create-agent' | 'explore-templates' | 'import-csv'): void
}>()
</script>

<template>
  <Menu.Root v-slot="{ getTriggerProps, menu }">
    <DarwinButton
      class="w-12"
      variant="black"
      data-test="new-project-button-homepage"
      aria-label="Create new project"
      :size="size"
      rounded
      v-bind="{ ...getTriggerProps(), ...$attrs }"
    >
      <IconSprite icon="plus" />
    </DarwinButton>
    <Menu.Content class="min-w-[242px]">
      <Menu.Item
        data-test="explore-templates"
        label="Explore templates"
        @select="emit('explore-templates')"
      >
        <template #prefix>
          <div class="flex size-5 items-center justify-center text-icon-subtle">
            <IconSprite icon="templates" />
          </div>
        </template>
      </Menu.Item>
      <Menu.Item
        label="Import CSV File"
        @select="emit('import-csv')"
      >
        <template #prefix>
          <div class="flex size-5 items-center justify-center text-icon-subtle">
            <IconSprite icon="table" />
          </div>
        </template>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item
        label="Start from scratch"
        @click="
          () => {
            menu.setOpen(false)
            emit('create-agent')
          }
        "
      />
    </Menu.Content>
  </Menu.Root>
</template>
